import { useEffect } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useScrollToEnd(lastElementRef: React.MutableRefObject<HTMLDivElement | null>, deps: any[]) {
  useEffect(() => {
    lastElementRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, lastElementRef.current]);
}
